<template>
  <div id="interview-change-pay">

    <!-- 可用余额 -->
    <div class="avaliable-balance">
      <div class="balance-box" v-if="!User.is_palmyou">
        <img src="../../assets/imgs/ordering/balance.png">
        <span class="title">可用余额</span>
        <span class="number">￥{{balance/100}}</span>
      </div>
    </div>

    <!-- 订单费用明细 -->
    <div class="order-pay-infos">

      <ul class="order-pay-items">
        <li>
          <label>修改赴馆时间（￥{{price}} <span>×</span> {{count}}）</label>
          <span>￥{{price*100*count/100}}</span>
        </li>

      </ul>

      <!-- 应付金额 -->
      <div class="total-pay">
        <label>应付金额</label>
        <span><i>￥</i>{{price*100*count/100}}</span>
      </div>

      <el-button type="primary" class="pay-button" @click="pay()">立即支付</el-button>
      <el-button type="default" class="refuse-update" @click="$emit('refuseUpdateDate')" v-if="apply_by">拒绝修改</el-button>
    </div>
  </div>
</template>

<script>
import User from '@/libs/user';

export default {
  name: 'interview-change-pay',
  props: {
    balance: {
      type: Number,
      required: true,
    },
    count: {
      type: Number,
      required: true,
    },
    price: {
      type: Number,
      required: true,
    },
    // 是否展示拒绝修改按钮
    apply_by: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      User,
    };
  },
  methods: {
    pay() {
      this.$emit('pay');
    },
    getPayAmount() {
      return this.price * this.count;
    },
  },
};
</script>

<style lang="less">
@import '../../assets/less/variable.less';

#interview-change-pay {
  background-color: white;
  display: flex;
  margin-top: 10px;
  padding: 30px;
  .refuse-update{
    margin-left: 0;
    margin-top: 10px;
  }
  div.avaliable-balance {
    flex: 1;
    display: flex;
    div.balance-box {
      border-radius: 4px;
      background-color: @lightGray;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 0 20px;
      height: 60px;
      img {
        width: 20px;
        height: 20px;
      }
      span.title {
        margin-left: 10px;
        font-size: 16px;
        color: @text-sliver;
      }
      span.number {
        margin-left: 10px;
        font-size: 16px;
        color: @text-dark;
      }
    }
  }
  div.order-pay-infos {
    display: flex;
    flex-direction: column;
    min-width: 250px;
    ul.order-pay-items {
      width: 100%;
      list-style-type: none;
      li {
        width: 100%;
        display: flex;
        font-size: 14px;
        margin-bottom: 12px;
        label {
          color: @text-sliver;
          display: flex;
          flex: 1;
          span{
            padding: 0 5px;
          }
        }
        span {
          color: @text-dark;
          display: flex;
          justify-content: flex-end;
        }
      }
    }
  }
  div.total-pay {
    display: flex;
    align-items: center;
    height: 54px;
    border-top: 1px solid @border;
    label {
      font-size: 14px;
      color: @text-sliver;
      flex: 1;
    }
    span {
      font-size: 24px;
      color: @orange;
      font-weight: 600;
      i {
        font-size: 16px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/order-detail/interview-change-pay.vue